import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import AnimatedPage from "../components/AnimatedPage";
import Header from "../components/Header";
import Footer from "../components/Footer";

function ResetPassword() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const navigate = useNavigate();

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, [profile]);

    const { register, handleSubmit } = useForm();

    const onSubmit = (data) => {
        if (data.password !== data.checkpassword) {
            swal("Thông báo", "Xác nhận mật khẩu mới không đúng", "error");
            return false;
        }
        const formData = {
            password: data.oldpassword,
            newpassword: data.password
        };
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/password`, formData)
            .then((res) => {
                swal({
                    title: "Thông báo",
                    text: "Đổi mật khẩu thành công",
                    icon: "success",
                    buttons: "OK"
                }).then(() => {
                    navigate("/profile");
                });
            })
            .catch((err) => swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response.data.message : "Đã có lỗi xảy ra", "error"));
    };

    return (
        <AnimatedPage>
            <Header profile={profile} />

            <style>{`
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    overflow-y: auto !important;
                    background-color: #e3e1e2 !important; 
                    margin: 0; padding: 0;
                }
                
                .reset-wrapper {
                    padding-bottom: 100px;
                    background-color: #e3e1e2;
                    min-height: 100vh;
                    padding-top: 20px; /* Thêm khoảng cách phía trên vì đã bỏ banner */
                }

                /* ================================================== */
                /* FORM ĐỔI MẬT KHẨU                               */
                /* ================================================== */
                .reset-content { padding: 0 15px 20px 15px; }
                
                .form-box { 
                    background: #fff; 
                    padding: 20px 15px; 
                    border-radius: 8px; 
                    box-shadow: 0 2px 6px rgba(0,0,0,0.1); 
                }
                
                .input-group {
                    margin-bottom: 18px;
                }
                .input-group label {
                    display: block;
                    font-weight: bold;
                    margin-bottom: 8px;
                    color: #444;
                    font-size: 14px;
                }
                .ipadd { 
                    width: 100%; 
                    padding: 14px 15px; 
                    border: 1px solid #ccc; 
                    border-radius: 5px; 
                    font-size: 14px; 
                    outline: none; 
                    color: #333;
                    background: #f9f9f9;
                    transition: border 0.3s;
                }
                .ipadd:focus {
                    border-color: #b71c1c;
                    background: #fff;
                }
                
                .btn-submit { 
                    width: 100%; 
                    background: #b71c1c; 
                    color: #fff; 
                    font-weight: bold; 
                    padding: 14px; 
                    border: none; 
                    border-radius: 5px; 
                    font-size: 16px; 
                    cursor: pointer; 
                    text-transform: uppercase;
                    margin-top: 10px;
                    box-shadow: 0 3px 6px rgba(0,0,0,0.2);
                }
                .btn-submit:active {
                    background: #961616;
                    transform: scale(0.98);
                }
            `}</style>

            <div className="reset-wrapper">
                
                {/* NỘI DUNG FORM */}
                <div className="reset-content">
                    <form className="form-box" onSubmit={handleSubmit(onSubmit)}>
                        
                        <div className="input-group">
                            <label>Mật khẩu cũ</label>
                            <input
                                className="ipadd"
                                type="password"
                                {...register("oldpassword", { required: true })}
                                placeholder="Nhập mật khẩu hiện tại"
                            />
                        </div>
                        
                        <div className="input-group">
                            <label>Mật khẩu mới</label>
                            <input
                                className="ipadd"
                                type="password"
                                {...register("password", { required: true })}
                                placeholder="Nhập mật khẩu mới"
                            />
                        </div>
                        
                        <div className="input-group">
                            <label>Xác nhận mật khẩu mới</label>
                            <input
                                className="ipadd"
                                type="password"
                                {...register("checkpassword", { required: true })}
                                placeholder="Nhập lại mật khẩu mới"
                            />
                        </div>
                        
                        <button type="submit" className="btn-submit">
                            Xác nhận
                        </button>
                        
                    </form>
                </div>
            </div>
            
            <Footer />
        </AnimatedPage>
    );
}

export default ResetPassword;